// Module
var code = "<div> <span> <i class=\"fa fa-shopping-cart\"></i> <div class=cartTotal ng-class=\"{hasItems: ngCart.totalItems()}\"> <span> {{ ngCart.totalItems() }}</span> </div> </span> <span ng-show=\"ngCart.totalItems() || totalCost\">{{ totalCost | currency }}</span> </div> ";
// Exports
module.exports = code;